const defaultTranslations = {
  yes: "Yes",
  no: "No",
  next: "Next",
  close: "Close",
  submit: "Submit",
  welcome: "Welcome",
  tryAgain: "Restart",
  result: "Result",
  quiz: "Quiz",
  raffle: "Raffle",
  thankYou: "Thank you for your participation!",
  participants: "Participants",
  confirmRegistration:
    "You received an email to confirm your registration. Please click on the link in the email to finish your registration.",
  registerAgain: "Participant Registration",
  registerNowCall: "Register now for free",
  showReadersChoice: "See readers' choice",
  showYourSelection: "Back to your selection",
  onlyWithRegistration: `You must be registered in order to save your data. Click on <b>"Submit selection"</b> to register <b>completely free</b> of charge.`,
  request: {
    pending: "Sending your request ...",
    error: "Your request has failed due to a technical error",
    success: "Request Sent",
  },
  registration: {
    next: "Next Step",
    submit: "Send and Participate",
    required: "Required",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Your email address",
    male: "Mr.",
    female: "Mrs.",
    street: "Street",
    houseNumber: "House Nr.",
    postalcode: "Postal Code",
    city: "City",
    telephone: "Phone",
    startInfo:
      "Please enter your personal details in order to take part in the competition.",
    prizeInfo: "Please fill in your address for the prize notification.",
    termsAndConditions: (link: string) =>
      `By sending your data you are agreeing to the <a href="${link}" target="_blank">Terms and Conditions</a>.`,
    privacy: "Notes on data-usage policy",
    advertisementOptInLabelAS: (link: string) =>
      `Ja, ich möchte, dass die Axel Springer SE mir Newsletter per E-Mail und/oder Push-Nachrichten mit Produktangeboten
und/oder Medienangeboten der Axel Springer Medien zuschickt. Meine Einwilligung kann ich jederzeit
<a href="${link}" target="_blank">widerrufen</a>.`,
    advertisementOptInLabelAS2:
      'Meine E-Mail-Adresse darf zum Zwecke des Retargeting in pseudonymisierter Form mit E-Mail-Adressen von Werbepartnern des Vermarkters der Axel Springer SE abgeglichen werden, wenn ich dem jeweiligen Werbepartner ebenfalls meine Einwilligung (z.B. auf dessen Website) hierfür erteilt habe und kein Pur-Abo abgeschlossen habe. Meine Einwilligung kann ich jederzeit unter dem Link „Widerruf Nutzerkennungen“ durch Widerruf "Axel Springer Nutzerkennung" am Ende der Website widerrufen. Nähere Informationen zu den Verarbeitungen, meinen Rechten und den Rollen der Axel Springer SE, dem Vermarkter Media Impact und den Werbetreibenden als gemeinsam Verantwortliche finde ich in der Datenschutzerklärung.',
  },
  score: {
    title: "Correct answers",
    retry: "Restart",
  },
  answerSlide: {
    correctAnswer: "This is correct!",
    wrongAnswer: "Wrong!",
    next: "Next",
  },
  pollSummary: {
    title: "Summary of all Votes",
    resultText: "voted like you",
  },
  quizSummary: {
    title: "Evaluation of your answers",
    resultText: "Correct Answers",
  },
  secretSummary: {
    defaultText: "The result of the poll will be published at a later date.",
    defaultTextWithEndDate: (dateString: string) =>
      `The result of the poll will be published on ${dateString}.`,
    surveyEndedTitle: "The survey is finished!",
    surveyEndedMessage:
      "Unfortunately, participation in this survey is no longer possible. Thank you very much for your interest.",
  },
  endedPoll: "The vote has already ended.",
  endedVoting: "The vote has already ended.",
  question: "Question",
  quizEndedIntro: {
    title: (quizType: string) => `${quizType} finished`,
    text: (quizType: string, date: string, time: string) =>
      `The ${quizType} ended on ${date} at ${time}. Unfortunately, participation is currently not possible.`,
  },
  quizFutureIntro: {
    title: "Quiz starts soon",
    text: (quizType: string, date: string, time: string) =>
      `The ${quizType} starts on ${date} at ${time}. Participation is possible from this point on.`,
  },
  yourSelection: "Your Selection",
  submitSelection: "Submit Selection",
  votingOverlay: (count: number) =>
    `Please select\n#${count}\nmore ${count === 1 ? "option" : "options"}`,
  imageCopyright: "Image copyrights",
  source: "Source",
  pollMultipleChoiceLabel: "Choose as many options as you want",
};

const germanTranslations = Object.assign({}, defaultTranslations, {
  yes: "Ja",
  no: "Nein",
  next: "Weiter",
  close: "Schliessen",
  submit: "Absenden",
  tryAgain: "Neu starten",
  result: "Ergebnis",
  quiz: "Quiz",
  raffle: "Gewinnspiel",
  thankYou: "Vielen Dank für Ihre Teilnahme!",
  participants: "Teilnehmer",
  confirmRegistration:
    "Es wurde eine E-Mail zur Bestätigung Ihrer Registrierung an die angegebene Adresse versandt. Um die Registrierung abzuschließen, klicken Sie bitte auf den Link in der E-Mail.",
  registerAgain: "Teilnehmerregistrierung",
  registerNowCall: "Jetzt kostenlos registrieren",
  showReadersChoice: "Leser-Auswahl ansehen",
  showYourSelection: "Zurück zu Deiner Auswahl",
  onlyWithRegistration: `Um Ihre Angaben speichern zu können, müssen Sie registriert sein. Klicken Sie auf <b>„Auswahl speichern“</b>, um sich <b>völlig kostenlos</b> zu registrieren.`,
  request: {
    pending: "Anfrage wird versendet ...",
    error: "Ihre Anfrage ist aufgrund eines technischen Fehlers fehlgeschlagen",
    success: "Anfrage gesendet",
  },
  registration: {
    next: "Weiter zur Anschrift",
    submit: "Absenden und Teilnehmen",
    required: "Pflichtfeld",
    welcome: "Willkommen",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "Ihre E-Mail-Adresse",
    male: "Herr",
    female: "Frau",
    street: "Straße",
    houseNumber: "Haus Nr.",
    postalcode: "Postleitzahl",
    city: "Stadt",
    telephone: "Telefon",
    startInfo:
      "Bitte machen Sie noch Angaben zu Ihrer Person, um am Gewinnspiel teilnehmen zu können.",
    prizeInfo:
      "Bitte ergänzen Sie noch Ihre Adresse für die Gewinnbenachrichtigung.",
    termsAndConditions: (link: string) =>
      `Bei Absendung Ihrer Daten erklären Sie sich mit den <a href="${link}" target="_blank">Teilnahmebedingungen</a> einverstanden.`,
    privacy: "Hinweise zur Datennutzung",
    advertisementOptInLabelAS: (link: string) =>
      `Ja, ich möchte, dass die Axel Springer SE mir Newsletter per E-Mail und/oder Push-Nachrichten mit Produktangeboten
und/oder Medienangeboten der Axel Springer Medien zuschickt. Meine Einwilligung kann ich jederzeit
<a href="${link}" target="_blank">widerrufen</a>.`,
    advertisementOptInLabelAS2:
      'Meine E-Mail-Adresse darf zum Zwecke des Retargeting in pseudonymisierter Form mit E-Mail-Adressen von Werbepartnern des Vermarkters der Axel Springer SE abgeglichen werden, wenn ich dem jeweiligen Werbepartner ebenfalls meine Einwilligung (z.B. auf dessen Website) hierfür erteilt habe und kein Pur-Abo abgeschlossen habe. Meine Einwilligung kann ich jederzeit unter dem Link „Widerruf Nutzerkennungen“ durch Widerruf "Axel Springer Nutzerkennung" am Ende der Website widerrufen. Nähere Informationen zu den Verarbeitungen, meinen Rechten und den Rollen der Axel Springer SE, dem Vermarkter Media Impact und den Werbetreibenden als gemeinsam Verantwortliche finde ich in der Datenschutzerklärung.',
  },
  score: {
    title: "Antworten richtig",
    retry: "Neu starten",
  },
  answerSlide: {
    correctAnswer: "Das ist richtig!",
    wrongAnswer: "Leider falsch!",
    next: "Weiter",
  },
  pollSummary: {
    title: "Übereinstimmung mit allen Abstimmenden",
    resultText: "stimmten wie Sie",
  },
  quizSummary: {
    title: "Auswertung Ihrer Antworten",
    resultText: "Antworten richtig",
  },
  secretSummary: {
    defaultText:
      "Das Ergebnis der Umfrage wird zu einem späteren Zeitpunkt veröffentlicht.",
    defaultTextWithEndDate: (dateString: string) =>
      `Das Ergebnis der Umfrage wird am ${dateString} veröffentlicht.`,
    surveyEndedTitle: "Die Umfrage ist beendet!",
    surveyEndedMessage:
      "Eine Teilnahme an der Umfrage ist leider nicht mehr möglich. Vielen Dank für das Interesse.",
  },
  endedPoll: "Die Abstimmung wurde bereits beendet.",
  endedVoting: "Die Abstimmung wurde bereits beendet.",
  question: "Frage",
  quizEndedIntro: {
    title: (quizType: string) => `${quizType} beendet`,
    text: (quizType: string, date: string, time: string) =>
      `Das ${quizType} ist am ${date} um ${time} abgelaufen. Eine Teilnahme ist im Moment leider nicht möglich.`,
  },
  quizFutureIntro: {
    title: (quizType: string) => `${quizType} noch nicht gestartet`,
    text: (quizType: string, date: string, time: string) =>
      `Das ${quizType} startet am ${date} um ${time}. Eine Teilnahme ist ab diesem Zeitpunkt möglich.`,
  },
  yourSelection: "Ihre Auswahl",
  submitSelection: "Auswahl Speichern",
  votingOverlay: (count: number) => `Bitte noch\n#${count}\nauswählen`,
  imageCopyright: "Bildrechte",
  source: "Quelle",
  pollMultipleChoiceLabel: "Wählen Sie beliebig viele Möglichkeiten aus",
});
// @see https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Internationalization
export default {
  en_US: defaultTranslations,
  de_DE: germanTranslations,
};
